/* eslint-disable react/prop-types */
import { React } from 'react';

import { Icon, Message } from 'semantic-ui-react';

// eslint-disable-next-line arrow-body-style
const DisplayLoading = ({ loadingMessage, iconName }) => {
  return (
    <>
      {loadingMessage && (
        <Message icon>
          <Icon name={iconName} loading />
          <Message.Content>
            <Message.Header>Juste une seconde</Message.Header>
            Nous récupérons ce contenu pour vous.
          </Message.Content>
        </Message>
      )}
    </>
  );
};
export default DisplayLoading;
